import { render } from "./MyButton.vue?vue&type=template&id=fa97ad9e&ts=true"
import script from "./MyButton.vue?vue&type=script&lang=ts"
export * from "./MyButton.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/nice-life-contract/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__